import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, catchError, exhaustMap, switchMap } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { HttpParams } from '@angular/common/http';

import * as LilatesActions from '../actions/lilate.actions';
import { Router } from '@angular/router';
import { LilateService } from '../../service/lilate.service';
import { Lilate, LilateList } from '../../model/lilate.model';
import { LilateActionsUnions, LilateActionTypes } from '../actions/lilate.actions';
import { PlanService } from '../../service/plan.service';

@Injectable()
export class LilateEffects {

    constructor(
        private actions: Actions<LilateActionsUnions>,
        private _lilateService: LilateService,
        private _planService: PlanService,
        private _router: Router,
    ) { }

    getLilatesPast = createEffect(() =>
        this.actions.pipe(
            ofType(LilateActionTypes.GET_LIST_PAST),
            exhaustMap(() => {
                return this._lilateService.getLilatesPast().pipe(
                    map((lilates: LilateList) => {
                        return LilatesActions.GetLilatesSuccess(lilates, false);
                    }),
                    catchError(() => of(LilatesActions.GetLilatesFailure()))
                )
            }),
        )
    );

    /** Conservé pour PLAN_SUCCESS / PATCH_SUCCESS ; le dashboard appelle aussi le service en direct. */
    getLilatesUpcoming = createEffect(() =>
        this.actions.pipe(
            ofType(LilateActionTypes.GET_LIST_UPCOMING),
            switchMap((action) => {
                return this._lilateService.getLilatesUpcomings(action.params).pipe(
                    map((lilates: LilateList) => {
                        return LilatesActions.GetLilatesSuccess(lilates, true);
                    }),
                    catchError((err) => {
                        console.error('[LILATE] upcomings effect failed', err);
                        return of(LilatesActions.GetLilatesFailure());
                    }),
                );
            }),
        )
    );

    patchLilate = createEffect(() =>
        this.actions.pipe(
            ofType(LilateActionTypes.PATCH_LILATE),
            exhaustMap((action) => {
                return this._lilateService.patch(action.params, action.id).pipe(
                    map((lilate: Lilate) => {
                        if (action.plan) {
                            return LilatesActions.PlanLilate(lilate.id, action.teacher);
                        }
                        return LilatesActions.PatchSuccess();
                    }),
                    catchError(() => of(LilatesActions.PatchFailure()))
                )
            }),
            catchError(() => of(LilatesActions.PatchFailure())),
        )
    );


    planLilate = createEffect(() =>
        this.actions.pipe(
            ofType(LilateActionTypes.PLAN_LILATE),
            exhaustMap((action) =>
                from(this._planService.postPlan({
                    algorithm: "book_lilate_exam",
                    lilate: action.id,
                    teacher: action.teacher
                })).pipe(
                    map(() => {
                        this._router.navigateByUrl('/dashboard');
                        return LilatesActions.PlanSuccess();
                    }),
                    catchError(() => of(LilatesActions.PlanFailure()))
                )
            ),
            catchError(() => of(LilatesActions.PlanFailure())),
        )
    );

    getLilates = createEffect(() =>
        this.actions.pipe(
            ofType(LilateActionTypes.GET_LISTING),
            exhaustMap(action => {
                return this._lilateService.get(action.params).pipe(
                    map((lilates: LilateList) => {
                        return LilatesActions.GetLilatesListingSuccess({ payload: lilates });
                    }),
                    catchError(() => of(LilatesActions.GetLilatesListingFailure()))
                )
            })
        )
    );

    getLilatesFromUrl = createEffect(() =>
        this.actions.pipe(
            ofType(LilateActionTypes.GET_LISTING_URL),
            exhaustMap(action => {
                return this._lilateService.getFromUrl(action.url).pipe(
                    map((lilates: LilateList) => {
                        return LilatesActions.GetLilatesListingSuccess({ payload: lilates });
                    }),
                    catchError(() => of(LilatesActions.GetLilatesListingFailure()))
                )
            })
        )
    );

    /** Rafraîchit les LILATE à venir après réservation ou mise à jour. */
    refreshUpcomingsAfterMutation = createEffect(() =>
        this.actions.pipe(
            ofType(LilateActionTypes.PLAN_SUCCESS, LilateActionTypes.PATCH_SUCCESS),
            map(() => LilatesActions.GetLilatesUpcoming({ params: new HttpParams() })),
        ),
    );
}
